"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const ts_validators_1 = require("ts-validators");
const unknownRemoveAllRecursiveReferences = (value, recursiveReferencesProp) => {
    const recursiveReferences = recursiveReferencesProp || [];
    if ((0, ts_validators_1.valueIsArray)(value) || (0, ts_validators_1.valueIsRecord)(value)) {
        recursiveReferences.push(value);
    }
    if ((0, ts_validators_1.valueIsArray)(value)) {
        const filtered = value.filter((item) => !recursiveReferences.includes(item));
        return filtered.map((item) => unknownRemoveAllRecursiveReferences(item, recursiveReferences));
    }
    if ((0, ts_validators_1.valueIsRecord)(value)) {
        const newValue = Object.assign({}, value);
        Object.entries(newValue).forEach(([key, itemValue]) => {
            if (recursiveReferences.includes(itemValue)) {
                delete newValue[key];
                return;
            }
            const newItemValue = unknownRemoveAllRecursiveReferences(itemValue, recursiveReferences);
            newValue[key] = newItemValue;
        });
        return newValue;
    }
    return value;
};
exports.default = unknownRemoveAllRecursiveReferences;
